import classNames from 'classnames';
import { format } from 'date-fns';
import { Badge, Button, Heading } from 'yoso';
import { AuthLink, AuthLinkProps } from '~/components/Auth/Link/AuthLink';
import { BaseCard } from '~/components/Card';
import { Countdown } from '~/components/Countdown/v2/Countdown';
import heroStyles from '~/components/Hero/Hero.module.scss';
import { T } from '~/components/I18n';
import { useLandEvent } from '~/components/Land/Event';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import type { LandEventHeroProps } from '../LandEventHero';
import styles from '../LandEventHero.module.scss';
export const InProgressLandEventHero = ({ id, className }: LandEventHeroProps) => {
  const {
    data: { startAt, endAt, announcedAt, week },
    isFetched,
  } = useLandEvent(id);

  return (
    <BaseCard
      className={classNames(
        heroStyles.root,
        styles.root,
        {
          [styles.loading]: !isFetched,
        },
        className
      )}
      size="large">
      <Badge className={heroStyles.badge} color="secondary">
        <T name="citizen_event_status_live" />
      </Badge>
      <Heading level={3} className={heroStyles.heading}>
        <T name="citizen_land_title_live" options={[week]} />
      </Heading>
      <DescriptionList className={heroStyles.list}>
        <dt>
          <strong>
            <T name="citizen_event_remainingtime" />
          </strong>
        </dt>
        <dd>
          <Countdown className={heroStyles.heading} value={endAt} days={false} />
        </dd>
      </DescriptionList>
      <DescriptionList layout="responsive" className={heroStyles.sublist}>
        <dt>
          <T name="citizen_arcade_game_challenge_desc1" />
        </dt>
        <dd>
          {format(startAt, 'P p')} ~ {format(endAt, 'P p')}
        </dd>
        <dt>
          <T name="citizen_event_winners_title" />
        </dt>
        <dd>{format(announcedAt, 'P')}</dd>
      </DescriptionList>
      <Button<AuthLinkProps>
        className={classNames(heroStyles.button, heroStyles.fixedButton)}
        as={AuthLink}
        to="#join"
        size="large"
        data-event="click"
        data-event-target="land_main_join_now_btn"
        replace>
        <T name="citizen_button_title_view_land" />
      </Button>
    </BaseCard>
  );
};
